var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CustomElement, Component, Prop, Event, html, nothing } from '@sick-davinci/ce-decorators';
import { style } from './Tabs.style';
export
/**
 * A `davinci-tabs` groups several `davinci-tab`s and shows a tab bar for switching between the *tab*s.
 * @example
 * ```html
 *    <davinci-tabs>
 *        <davinci-tab label="Modern1">any content</davinci-tab>
 *        <davinci-tab selected label="Modern2">any other</davinci-tab>
 *    </davinci-tabs>
 *
 *    <davinci-tabs type="classic">
 *        <davinci-tab label="Classic1">any content</davinci-tab>
 *        <davinci-tab selected label="Classic2">any other</davinci-tab>
 *    </davinci-tabs>
 * ```
 * @slot {davinci-tab[]} *tab*s grouped within davinci-tab
 */
let Tabs = (_dec = Component({
  tag: 'davinci-tabs',
  style: [style]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Event('tab-change'), _dec9 = Reflect.metadata("design:type", Object), _dec10 = Event('close-tab'), _dec11 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class Tabs extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "type", _descriptor, this);

    _initializerDefineProperty(this, "closeable", _descriptor2, this);

    _initializerDefineProperty(this, "tabChange", _descriptor3, this);

    _initializerDefineProperty(this, "closeTab", _descriptor4, this);

    _defineProperty(this, "tabElList", new Array());

    _defineProperty(this, "_index", 0);
  }

  /**
   * ToDo: mark as public property `selectedIndex` as deprecated
   * Change to `@State() private selectedIndex` to maintain selection without much refactoring.
   * Exclusively use selected property on tab-elements to mark tab as selected.
   */

  /**
   * Index of the selected tab with 0 being the first tab.
   */
  set selectedIndex(index) {
    // DAVIBE-527: check and fix type of index-argument.
    if (typeof index !== 'number' || !Number.isInteger(index)) {
      index = 0;
    }

    const selectableIndex = this._getSelectableIndex(index);

    if (selectableIndex !== index) {
      // force reflect to attribute
      this.setAttribute('selected-index', selectableIndex.toString());
    }

    if (selectableIndex !== this._index) {
      this._index = selectableIndex;

      this._selectTab(); // TODO A change-event must only be emitted after a direct user interaction.
      // Currently, a change-event may also be emitted if a tab changes its state
      // (e.g. becomes disabled) or if the selected index becomes changed via script.
      // This needs to be fixed in a future release.


      this.tabChange.emit(this._index);
    }
  }

  get selectedIndex() {
    return this._index;
  }
  /**
   * Emitted if a tab is selected. Emits the tab index. The index starts with 0.
   */


  render() {
    return html`
    <div class="labels">
      ${this.tabElList.map((v, i) => html`
        <span
          tabindex=${v.disabled ? '-1' : '0'}
          class="headline"
          id=${i}
          ?selected=${this.selectedIndex === i}
          ?disabled=${v.disabled}
          title="${v.title ? v.title : ''}"
          @click=${this._onTabSelectionClick}
          @keyup=${this._onKeyUp}
          @keydown=${this._onKeyDown}}
        >
          ${v.renderIcon()}
          <span class="label">${v.label}</span>
          ${this._renderCloseIcon()}
        </span>`)}
    </div>
    <div class="tabs">
      <slot @slotchange="${this._onSlotChange}"></slot>
    </div>`;
  }

  componentConnected() {
    this.addEventListener('_change', this._onTabChange);
  }

  componentDisconnected() {
    this.removeEventListener('_change', this._onTabChange);
  }

  componentFirstRender() {
    // Safari (does not call @slotchange) fix -- https://github.com/whatwg/dom/issues/447
    this._onSlotChange();
  }

  _onTabSelectionClick(e) {
    const tab = e.target.classList.contains('headline') ? e.target : e.target.parentElement;
    this.selectedIndex = tab.disabled ? this.selectedIndex : +tab.id;
  }

  _onKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
    }
  }

  _onKeyUp(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.stopPropagation();
      const tab = e.target.classList.contains('headline') ? e.target : e.target.parentElement;
      this.selectedIndex = tab.disabled ? this.selectedIndex : +tab.id;
    }
  }
  /**
   * Removes the related Tab-element from the dom
   * Further handling is triggered by slot-changed -> same behavior as removing an element by manual dom manipulation
   * @param e MouseEvent
   */


  _onCloseClick(e) {
    e.stopPropagation();

    this._removeTabFromDom(+e.target.parentElement.id);
  }

  _removeTabFromDom(tabIndex) {
    this.removeChild(this.tabElList[tabIndex]);
    this.closeTab.emit(tabIndex);
  } // iterates through tabs and finds the first enabled one


  _findClosestEnabledTabIndex(fromIndex, iter) {
    let testIndex = fromIndex;

    while (testIndex > -1 && testIndex < this.tabElList.length) {
      if (this.tabElList[testIndex].disabled) {
        testIndex = iter(testIndex);
      } else {
        return testIndex;
      }
    }

    return -1;
  }
  /**
   * General logic for chanaging selections concerning the disabled attribute of tabs
   * @param index the index of the tab to be selected.
   * @return true if the index has changed else false.
   */


  _getSelectableIndex(index) {
    if (index >= this.tabElList.length) {
      index = this.tabElList.length - 1;
    } else if (index < 0) {
      index = 0;
    } // Use closest enabled tab AFTER the current one if the current one is disabled


    let testIndex = this._findClosestEnabledTabIndex(index, i => ++i);

    if (testIndex === -1) {
      // Use closest enabled tab BEFORE the current one if the current one is disabled
      testIndex = this._findClosestEnabledTabIndex(index, i => --i);
    }

    return testIndex;
  } // updates { @link this.tabElList } triggers the selection-update


  _onSlotChange() {
    const slotElement = this.shadowRoot.querySelector('slot');
    const slotAssignedNodes = slotElement.assignedNodes();
    const slotAssignedTabs = slotAssignedNodes.filter(node => node.nodeName.toLowerCase() === 'davinci-tab');
    slotAssignedTabs.forEach((tab, i) => {
      tab.index = i;
    });

    const newIndex = this._getIndexForChangedTabList(this.tabElList, slotAssignedTabs);

    this.tabElList = slotAssignedTabs;
    this.selectedIndex = this._getSelectableIndex(newIndex);

    this._selectTab(); // enforce selection of first tab by default (this._index defaults to 0 => no setter-execution)


    Promise.resolve().then(() => {
      this.scheduleRender(true);
    });
  }
  /**
   * Holds the logic for changing / keeping the selection when tabs are added / removed from the list.
   * Does NOT take care of disabled tabs. This is done by {@link _getSelectableIndex()}.
   * @param oldList
   * @param changedList
   * @returns new index
   */


  _getIndexForChangedTabList(oldList, changedList) {
    let newIndex = this.selectedIndex;

    const newTab = this._getNewTab(oldList, changedList);

    if (newTab && !newTab.disabled) {
      // an enabled Tab was inserted
      newIndex = newTab.selected // if new tab is selected
      ? newTab.index // change selection to new tab
      : newTab.index > this.selectedIndex // else if insertion after current selection
      ? this.selectedIndex // index can be unchanged
      : this.selectedIndex + 1; // index must increase by 1
    } else if (newTab && newTab.index <= this.selectedIndex) {
      // an (disabled) Tab was inserted befor/at current selection
      newIndex = this.selectedIndex + 1; // => increase index by 1
    } else if (!newTab) {
      // tab removed, or no change in tab-list
      const removedTabIndex = this._getRemovedTabIndex(oldList, changedList);

      if (removedTabIndex !== -1 && removedTabIndex < this.selectedIndex) {
        // removed tab is at/before current selection
        newIndex = this.selectedIndex - 1; // => reduce selection-index by 1
      }
    }

    return newIndex;
  } // returns the index of the removed tab


  _getRemovedTabIndex(largerList, smallerList) {
    const r = this._findAdditionalElement(smallerList, largerList);

    return r ? r.index : -1;
  } // returns the added tab in the list (undefined, if no additional tab found)


  _getNewTab(smallerList, largerList) {
    const r = this._findAdditionalElement(smallerList, largerList);

    return r && r.list[r.index];
  }
  /**
   * Finds the (first) disparity between the two lists and returns the index of the additional element.
   * Returns undefined in case, smallerList is of same or greater length, then largerList.
   * @param smallerList
   * @param largerList
   * @returns
   */


  _findAdditionalElement(smallerList, largerList) {
    if (smallerList.length >= largerList.length) {
      return undefined;
    } // performance: start from the end of the list, because most elements will be added to the end of the list


    for (let i = largerList.length - 1; i >= 0; i--) {
      if (!smallerList.includes(largerList[i])) {
        return {
          list: largerList,
          index: i
        };
      }
    }

    return undefined;
  }
  /**
   * Holds the logic for changing / keeping the selection when tabs are selected / disabled.
   * @param e CustomEvent<{ tab: Tab, changed: string }>
   */


  _onTabChange(e) {
    e.stopPropagation();
    const tab = e.detail.tab;

    switch (e.detail.changed) {
      case 'disabled':
        tab.disabled ? this.selectedIndex = this._getSelectableIndex(this.selectedIndex) : this.selectedIndex = this._getSelectableIndex(this.selectedIndex === -1 ? 0 : this.selectedIndex);
        break;

      case 'selected':
        tab.disabled ? this.selectedIndex = this._getSelectableIndex(this.selectedIndex) : this.selectedIndex = this._getSelectableIndex(tab.selected ? tab.index : this.selectedIndex);
        break;

      default:
        break;
    }

    this._selectTab();

    this.scheduleRender(true);
  }

  _selectTab() {
    this.tabElList.forEach((v, i) => {
      v.selected = i === this.selectedIndex;
    });
  }

  _renderCloseIcon() {
    if (this.type === 'classic' && this.closeable) {
      return html`<davinci-icon class="close" icon='navigation/close' @click=${this._onCloseClick}></davinci-icon>`;
    } else {
      return html`${nothing}`;
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'modern';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "closeable", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "selectedIndex", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedIndex"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "tabChange", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "closeTab", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
